function HowItWorks() {
  return (
    <section
      id="how-it-works"
      dir="rtl"
      className="
        w-full
        bg-[#f8ece5]
        font-['Cairo']
        box-border

        px-20
        py-[70px]

        max-[900px]:px-10
        max-[900px]:py-[60px]

        max-[650px]:px-5
        max-[650px]:py-10
        max-[650px]:overflow-hidden
      "
    >
      <h2
        className="
          text-center
          text-[32px]
          mb-[100px]
          text-[#171717]
          font-extrabold
          animate-fade-up

          max-[900px]:text-[26px]
          max-[900px]:mb-[60px]

          max-[650px]:text-[22px]
          max-[650px]:mb-8
        "
      >
        كيف يعمل طبختنا؟
      </h2>

      <div
        className="
          w-full
          max-w-[1200px]
          h-[400px]
          mx-auto
          relative

          max-[900px]:h-[340px]

          max-[650px]:h-auto
          max-[650px]:block
          max-[650px]:box-border
        "
      >

        {/* الخط */}
        <div
          aria-hidden="true"
          className="
            absolute
            top-1/2
            left-0
            right-0
            h-[2px]
            bg-[#d32f2f]
            z-[1]
            how-step-line

            max-[650px]:top-0
            max-[650px]:bottom-0
            max-[650px]:left-1/2
            max-[650px]:right-auto
            max-[650px]:w-[2px]
            max-[650px]:h-auto
            max-[650px]:-ml-px
            max-[650px]:z-0
          "
        ></div>

        {/* الخطوة 01 */}
        <div
          className="
            absolute
            w-[220px]
            h-full
            top-0
            right-0

            max-[900px]:w-[170px]

            max-[650px]:relative
            max-[650px]:flex
            max-[650px]:flex-row
            max-[650px]:items-center
            max-[650px]:w-full
            max-[650px]:h-auto
            max-[650px]:min-h-[90px]
            max-[650px]:mb-4
            max-[650px]:right-auto
            max-[650px]:box-border
          "
        >
          <div
            className="
              absolute
              left-1/2
              -translate-x-1/2
              bottom-[calc(50%+40px)]

              w-[220px]
              min-h-[125px]

              bg-white
              rounded-[18px]
              p-5
              box-border
              text-center
              border
              border-[#f3ddd8]
              how-step-card
              shadow-[0_8px_22px_rgba(120,32,24,0.08)]
              z-[2]

              after:content-['']
              after:absolute
              after:-bottom-10
              after:left-1/2
              after:-translate-x-1/2
              after:w-[2px]
              after:h-10
              after:bg-[#d32f2f]
              after:z-[1]

              max-[900px]:w-[170px]
              max-[900px]:p-[14px]
              max-[900px]:min-h-[110px]

              max-[650px]:relative
              max-[650px]:left-auto
              max-[650px]:translate-x-0
              max-[650px]:bottom-auto
              max-[650px]:ml-[calc(50%+26px)]
              max-[650px]:mr-0
              max-[650px]:w-[calc(50%-30px)]
              max-[650px]:min-h-[70px]
              max-[650px]:rounded-xl
              max-[650px]:p-[10px_12px]
              max-[650px]:text-right
              max-[650px]:after:hidden
            "
          >
            <span
              className="
                block
                text-[#d32f2f]
                text-xs
                font-bold

                max-[650px]:text-[9px]
                max-[650px]:mb-[3px]
              "
            >
              الخطوة 01
            </span>
            <h3
              className="
                mt-[10px]
                mb-2
                text-lg
                text-[#222]

                max-[900px]:text-[15px]

                max-[650px]:text-xs
                max-[650px]:font-extrabold
                max-[650px]:text-[#1a1a1a]
                max-[650px]:mt-0
                max-[650px]:mb-1
              "
            >
              اختاري الطبخة
            </h3>
            <p
              className="
                m-0
                text-xs
                leading-[1.8]
                text-[#777]

                max-[650px]:text-[10px]
                max-[650px]:text-[#888]
                max-[650px]:leading-[1.5]
              "
            >
              تصفحي الطبخات واختاري الطبخة المناسبة لك.
            </p>
          </div>

          <div
            aria-hidden="true"
            className="
              absolute
              top-1/2
              left-1/2
              -translate-x-1/2
              -translate-y-1/2

              w-[38px]
              h-[38px]

              rounded-full
              how-step-icon
              bg-[#d32f2f]
              text-white

              flex
              items-center
              justify-center

              text-xl
              z-[3]

              border-[3px]
              border-[#f8ece5]
              box-content
              shrink-0

              max-[650px]:w-8
              max-[650px]:h-8
            "
          >
            <svg
              width="22"
              height="22"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="w-[22px] h-[22px] max-[650px]:w-[14px] max-[650px]:h-[14px]"
            >
              <path
                d="M21.5318 20.4686L16.8378 15.7755C18.1983 14.1421 18.8767 12.047 18.7319 9.92618C18.5871 7.80531 17.6302 5.82191 16.0603 4.38859C14.4904 2.95526 12.4284 2.18235 10.3031 2.23065C8.17785 2.27895 6.15303 3.14474 4.64986 4.64791C3.14669 6.15108 2.2809 8.1759 2.2326 10.3012C2.1843 12.4264 2.95721 14.4885 4.39054 16.0584C5.82387 17.6283 7.80726 18.5852 9.92813 18.73C12.049 18.8748 14.144 18.1963 15.7774 16.8358L20.4706 21.5299C20.6119 21.6712 20.8027 21.7502 21.0012 21.7502C21.1997 21.7502 21.3905 21.6712 21.5318 21.5299C21.6731 21.3886 21.7521 21.1978 21.7521 20.9993C21.7521 20.8007 21.6731 20.6099 21.5318 20.4686ZM3.75119 10.4992C3.75119 9.16421 4.14707 7.85917 4.88877 6.74914C5.63047 5.63911 6.68468 4.77394 7.91808 4.26305C9.15148 3.75216 10.5087 3.61849 11.8181 3.87894C13.1274 4.13939 14.3302 4.78226 15.2742 5.72627C16.2182 6.67027 16.861 7.87301 17.1215 9.18238C17.3819 10.4917 17.2483 11.849 16.7374 13.0824C16.2265 14.3158 15.3613 15.37 14.2513 16.1117C13.1413 16.8534 11.8362 17.2492 10.5012 17.2492C8.71159 17.2473 6.99585 16.5355 5.73041 15.27C4.46497 14.0046 3.75318 12.2888 3.75119 10.4992Z"
                fill="white"
              />
            </svg>
          </div>
        </div>

        {/* الخطوة 02 */}
        <div
          className="
            absolute
            w-[220px]
            h-full
            top-0
            right-[25%]

            max-[900px]:w-[170px]

            max-[650px]:relative
            max-[650px]:flex
            max-[650px]:flex-row
            max-[650px]:items-center
            max-[650px]:w-full
            max-[650px]:h-auto
            max-[650px]:min-h-[90px]
            max-[650px]:mb-4
            max-[650px]:right-auto
            max-[650px]:box-border
          "
        >
          <div
            aria-hidden="true"
            className="
              absolute
              top-1/2
              left-1/2
              -translate-x-1/2
              -translate-y-1/2

              w-[38px]
              h-[38px]

              rounded-full
              how-step-icon
              bg-[#d32f2f]
              text-white

              flex
              items-center
              justify-center

              text-xl
              z-[3]

              border-[3px]
              border-[#f8ece5]
              box-content
              shrink-0

              max-[650px]:w-8
              max-[650px]:h-8
            "
          >
            <svg
              width="22"
              height="15"
              viewBox="0 0 24 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="w-[22px] h-[15px] max-[650px]:w-[14px] max-[650px]:h-[14px]"
            >
              <path
                d="M10.789 10.3073C11.7942 9.63809 12.5573 8.66317 12.9656 7.52671C13.3738 6.39024 13.4055 5.15256 13.056 3.99669C12.7064 2.84082 11.9941 1.82813 11.0245 1.10837C10.0549 0.388613 8.87937 0 7.6718 0C6.46423 0 5.28871 0.388613 4.31909 1.10837C3.34946 1.82813 2.6372 2.84082 2.28763 3.99669C1.93807 5.15256 1.96976 6.39024 2.37802 7.52671C2.78627 8.66317 3.54942 9.63809 4.55461 10.3073C2.73632 10.9774 1.18346 12.2176 0.127737 13.8426C-0.0347248 14.0921 0.0380512 14.4232 0.287547 14.5849C0.537043 14.7467 0.868255 14.6739 1.03022 14.4244C1.71098 13.3767 2.64282 12.5163 3.74090 11.9208C4.83897 11.3252 6.06849 11.0131 7.3178 11.0131C8.56711 11.0131 9.79663 11.3252 10.8947 11.9208C11.9928 12.5163 12.9246 13.3767 13.6056 14.4244C13.7156 14.5879 13.8855 14.7015 14.0787 14.7407C14.2718 14.7799 14.4726 14.7415 14.6376 14.6338C14.8027 14.5262 14.9187 14.3579 14.9607 14.1653C15.0026 13.9728 14.9671 13.7715 14.8619 13.6049C13.8062 11.9799 12.2534 10.7398 10.435 10.0696C10.5535 10.0298 10.6713 9.9697 10.789 10.3073ZM3.5468 5.62728C3.5468 4.81143 3.78873 4.01391 4.24199 3.33556C4.69525 2.6572 5.33948 2.12849 6.09323 1.81628C6.84698 1.50407 7.67638 1.42238 8.47655 1.58154C9.27672 1.74071 10.0117 2.13357 10.5886 2.71047C11.1655 3.28736 11.5584 4.02236 11.7175 4.82253C11.8767 5.62271 11.795 6.45211 11.4828 7.20585C11.1706 7.9596 10.6419 8.60383 9.96353 9.05709C9.28517 9.51035 8.48765 9.75228 7.6718 9.75228C6.57816 9.75104 5.52967 9.31605 4.75635 8.54273C3.98304 7.76941 3.54804 6.72092 3.5468 5.62728Z"
                fill="white"
              />
            </svg>
          </div>

          <div
            className="
              absolute
              left-1/2
              -translate-x-1/2
              top-[calc(50%+40px)]

              w-[220px]
              min-h-[125px]

              bg-white
              rounded-[18px]
              p-5
              box-border
              text-center
              border
              border-[#f3ddd8]
              how-step-card how-step-card-2
              shadow-[0_8px_22px_rgba(120,32,24,0.08)]
              z-[2]

              before:content-['']
              before:absolute
              before:-top-10
              before:left-1/2
              before:-translate-x-1/2
              before:w-[2px]
              before:h-10
              before:bg-[#d32f2f]
              before:z-[1]

              max-[900px]:w-[170px]
              max-[900px]:p-[14px]
              max-[900px]:min-h-[110px]

              max-[650px]:relative
              max-[650px]:left-auto
              max-[650px]:translate-x-0
              max-[650px]:top-auto
              max-[650px]:mr-[calc(50%+26px)]
              max-[650px]:ml-0
              max-[650px]:w-[calc(50%-30px)]
              max-[650px]:min-h-[70px]
              max-[650px]:rounded-xl
              max-[650px]:p-[10px_12px]
              max-[650px]:text-right
              max-[650px]:before:hidden
            "
          >
            <span
              className="
                block
                text-[#d32f2f]
                text-xs
                font-bold

                max-[650px]:text-[9px]
                max-[650px]:mb-[3px]
              "
            >
              الخطوة 02
            </span>
            <h3
              className="
                mt-[10px]
                mb-2
                text-lg
                text-[#222]

                max-[900px]:text-[15px]

                max-[650px]:text-xs
                max-[650px]:font-extrabold
                max-[650px]:text-[#1a1a1a]
                max-[650px]:mt-0
                max-[650px]:mb-1
              "
            >
              حددي عدد الأشخاص
            </h3>
            <p
              className="
                m-0
                text-xs
                leading-[1.8]
                text-[#777]

                max-[650px]:text-[10px]
                max-[650px]:text-[#888]
                max-[650px]:leading-[1.5]
              "
            >
              حددي عدد الأشخاص لتحصلي على المقادير الدقيقة.
            </p>
          </div>
        </div>

        {/* الخطوة 03 */}
        <div
          className="
            absolute
            w-[220px]
            h-full
            top-0
            left-[25%]

            max-[900px]:w-[170px]

            max-[650px]:relative
            max-[650px]:flex
            max-[650px]:flex-row
            max-[650px]:items-center
            max-[650px]:w-full
            max-[650px]:h-auto
            max-[650px]:min-h-[90px]
            max-[650px]:mb-4
            max-[650px]:left-auto
            max-[650px]:box-border
          "
        >
          <div
            className="
              absolute
              left-1/2
              -translate-x-1/2
              bottom-[calc(50%+40px)]

              w-[220px]
              min-h-[125px]

              bg-white
              rounded-[18px]
              p-5
              box-border
              text-center
              border
              border-[#f3ddd8]
              how-step-card how-step-card-3
              shadow-[0_8px_22px_rgba(120,32,24,0.08)]
              z-[2]

              after:content-['']
              after:absolute
              after:-bottom-10
              after:left-1/2
              after:-translate-x-1/2
              after:w-[2px]
              after:h-10
              after:bg-[#d32f2f]
              after:z-[1]

              max-[900px]:w-[170px]
              max-[900px]:p-[14px]
              max-[900px]:min-h-[110px]

              max-[650px]:relative
              max-[650px]:left-auto
              max-[650px]:translate-x-0
              max-[650px]:bottom-auto
              max-[650px]:ml-[calc(50%+26px)]
              max-[650px]:mr-0
              max-[650px]:w-[calc(50%-30px)]
              max-[650px]:min-h-[70px]
              max-[650px]:rounded-xl
              max-[650px]:p-[10px_12px]
              max-[650px]:text-right
              max-[650px]:after:hidden
            "
          >
            <span
              className="
                block
                text-[#d32f2f]
                text-xs
                font-bold

                max-[650px]:text-[9px]
                max-[650px]:mb-[3px]
              "
            >
              الخطوة 03
            </span>
            <h3
              className="
                mt-[10px]
                mb-2
                text-lg
                text-[#222]

                max-[900px]:text-[15px]

                max-[650px]:text-xs
                max-[650px]:font-extrabold
                max-[650px]:text-[#1a1a1a]
                max-[650px]:mt-0
                max-[650px]:mb-1
              "
            >
              جهزي المكونات
            </h3>
            <p
              className="
                m-0
                text-xs
                leading-[1.8]
                text-[#777]

                max-[650px]:text-[10px]
                max-[650px]:text-[#888]
                max-[650px]:leading-[1.5]
              "
            >
              نقوم بتجهيز جميع المكونات داخل صندوق طبختنا.
            </p>
          </div>

          <div
            aria-hidden="true"
            className="
              absolute
              top-1/2
              left-1/2
              -translate-x-1/2
              -translate-y-1/2

              w-[38px]
              h-[38px]

              rounded-full
              how-step-icon
              bg-[#d32f2f]
              text-white

              flex
              items-center
              justify-center

              text-xl
              z-[3]

              border-[3px]
              border-[#f8ece5]
              box-content
              shrink-0

              max-[650px]:w-8
              max-[650px]:h-8
            "
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 21 21"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="w-5 h-5 max-[650px]:w-[14px] max-[650px]:h-[14px]"
            >
              <path
                d="M20.0756 4.01906C20.0052 3.93481 19.9172 3.86705 19.8177 3.82056C19.7183 3.77407 19.6098 3.74998 19.5 3.75H4.37625L3.80625 0.615937C3.77485 0.443126 3.6838 0.286814 3.54897 0.174254C3.41414 0.0616938 3.24408 0.0000253849 3.06844 0H0.75C0.551088 0 0.360322 0.0790176 0.21967 0.21967C0.0790173 0.360322 0 0.551088 0 0.75C0 0.948912 0.0790173 1.13968 0.21967 1.28033C0.360322 1.42098 0.551088 1.5 0.75 1.5H2.4375L4.83375 14.6522C4.90434 15.0422 5.07671 15.4067 5.33344 15.7087C4.97911 16.0397 4.72336 16.4623 4.59455 16.9298C4.46575 17.3972 4.46892 17.8912 4.60371 18.3569C4.73851 18.8226 4.99966 19.2419 5.35821 19.5683C5.71676 19.8947 6.1587 20.1154 6.63502 20.2059C7.11134 20.2965 7.60344 20.2533 8.05673 20.0813C8.51003 19.9092 8.90682 19.615 9.2031 19.2312C9.49938 18.8474 9.68358 18.389 9.73527 17.907C9.78696 17.4249 9.70412 16.9379 9.49594 16.5H13.7541C13.5863 16.8513 13.4995 17.2357 13.5 17.625C13.5 18.1442 13.654 18.6517 13.9424 19.0834C14.2308 19.5151 14.6408 19.8515 15.1205 20.0502C15.6001 20.2489 16.1279 20.3008 16.6371 20.1996C17.1463 20.0983 17.614 19.8483 17.9812 19.4812C18.3483 19.114 18.5983 18.6463 18.6996 18.1371C18.8008 17.6279 18.7489 17.1001 18.5502 16.6205C18.3515 16.1408 18.0151 15.7308 17.5834 15.4424C17.1517 15.154 16.6442 15 16.125 15H7.04719C6.87155 15 6.70149 14.9383 6.56665 14.8257C6.43182 14.7132 6.34077 14.5569 6.30938 14.3841L6.01219 12.75H16.8872C17.4141 12.7499 17.9243 12.5649 18.3288 12.2272C18.7333 11.8896 19.0064 11.4206 19.1006 10.9022L20.2406 4.63406C20.2599 4.52572 20.2551 4.41447 20.2266 4.30818C20.1981 4.2019 20.1466 4.10319 20.0756 4.01906Z"
                fill="white"
              />
            </svg>
          </div>
        </div>

        {/* الخطوة 04 */}
        <div
          className="
            absolute
            w-[220px]
            h-full
            top-0
            left-0

            max-[900px]:w-[170px]

            max-[650px]:relative
            max-[650px]:flex
            max-[650px]:flex-row
            max-[650px]:items-center
            max-[650px]:w-full
            max-[650px]:h-auto
            max-[650px]:min-h-[90px]
            max-[650px]:mb-4
            max-[650px]:left-auto
            max-[650px]:box-border
          "
        >
          <div
            aria-hidden="true"
            className="
              absolute
              top-1/2
              left-1/2
              -translate-x-1/2
              -translate-y-1/2

              w-[38px]
              h-[38px]

              rounded-full
              how-step-icon
              bg-[#d32f2f]
              text-white

              flex
              items-center
              justify-center

              text-xl
              z-[3]

              border-[3px]
              border-[#f8ece5]
              box-content
              shrink-0

              max-[650px]:w-8
              max-[650px]:h-8
            "
          >
            <svg
              width="22"
              height="22"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="w-[22px] h-[22px] max-[650px]:w-[14px] max-[650px]:h-[14px]"
            >
              <path
                d="M21 10H3C2.44772 10 2 10.4477 2 11V20C2 20.5523 2.44772 21 3 21H21C21.5523 21 22 20.5523 22 20V11C22 10.4477 21.5523 10 21 10Z"
                stroke="white"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M16 10V7C16 5.93913 15.5786 4.92172 14.8284 4.17157C14.0783 3.42143 13.0609 3 12 3C10.9391 3 9.92172 3.42143 9.17157 4.17157C8.42143 4.92172 8 5.93913 8 7V10"
                stroke="white"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <circle cx="12" cy="15.5" r="1.5" fill="white" />
            </svg>
          </div>

          <div
            className="
              absolute
              left-1/2
              -translate-x-1/2
              top-[calc(50%+40px)]

              w-[220px]
              min-h-[125px]

              bg-white
              rounded-[18px]
              p-5
              box-border
              text-center
              border
              border-[#f3ddd8]
              how-step-card how-step-card-4
              shadow-[0_8px_22px_rgba(120,32,24,0.08)]
              z-[2]

              before:content-['']
              before:absolute
              before:-top-10
              before:left-1/2
              before:-translate-x-1/2
              before:w-[2px]
              before:h-10
              before:bg-[#d32f2f]
              before:z-[1]

              max-[900px]:w-[170px]
              max-[900px]:p-[14px]
              max-[900px]:min-h-[110px]

              max-[650px]:relative
              max-[650px]:left-auto
              max-[650px]:translate-x-0
              max-[650px]:top-auto
              max-[650px]:mr-[calc(50%+26px)]
              max-[650px]:ml-0
              max-[650px]:w-[calc(50%-30px)]
              max-[650px]:min-h-[70px]
              max-[650px]:rounded-xl
              max-[650px]:p-[10px_12px]
              max-[650px]:text-right
              max-[650px]:before:hidden
            "
          >
            <span
              className="
                block
                text-[#d32f2f]
                text-xs
                font-bold

                max-[650px]:text-[9px]
                max-[650px]:mb-[3px]
              "
            >
              الخطوة 04
            </span>
            <h3
              className="
                mt-[10px]
                mb-2
                text-lg
                text-[#222]

                max-[900px]:text-[15px]

                max-[650px]:text-xs
                max-[650px]:font-extrabold
                max-[650px]:text-[#1a1a1a]
                max-[650px]:mt-0
                max-[650px]:mb-1
              "
            >
              نوصّلها لبابك
            </h3>
            <p
              className="
                m-0
                text-xs
                leading-[1.8]
                text-[#777]

                max-[650px]:text-[10px]
                max-[650px]:text-[#888]
                max-[650px]:leading-[1.5]
              "
            >
              نرسل لك صندوق الطبخة جاهزاً لتبدأي الطبخ.
            </p>
          </div>
        </div>

      </div>
    </section>
  );
}

export default HowItWorks;